import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ZInput } from "@/components/ZInput";
import ZButton from "@/components/ZButton";
import TermsConsent from "@/components/TermsConsent";
import { Gift } from "lucide-react";

export default function VoucherClaimPage() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");
  const [accept, setAccept] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (!accept) { return setErr("Vous devez accepter les CGV et la politique de confidentialité."); }
    setLoading(true);
    try {
      const payload = { code: code.trim().toUpperCase() };
      if (!user) {
        if (!name.trim() || !email.trim()) { setLoading(false); return setErr("Renseignez votre nom et e-mail."); }
        payload.guest_name = name.trim();
        payload.guest_email = email.trim();
      }
      const r = await api.post("/vouchers/claim", payload);
      const v = r.data.voucher;
      const tokenParam = !user ? `?token=${encodeURIComponent(v.qr_payload)}` : "";
      nav(`/voucher/${v.id}${tokenParam}`);
    } catch (e) {
      setErr(errMsg(e));
    } finally { setLoading(false); }
  };

  return (
    <div className="z-container" style={{ maxWidth: 460 }} data-testid="voucher-claim-page">
      <h1 className="z-page-title">Réclamer un bon d'achat</h1>
      <p className="z-page-sub">Saisissez votre code pour ajouter le bon à votre portefeuille.</p>

      <form onSubmit={submit} className="z-card" style={{ padding: 24 }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 18 }}>
          <div className="z-role-icon"><Gift size={26} /></div>
        </div>
        <ZInput
          label="Code"
          value={code} onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder="EX. ABCD-1234" required
          style={{ textAlign: "center", fontFamily: "monospace", letterSpacing: 2, fontSize: 18 }}
          data-testid="vclaim-code"
        />
        {!user && (
          <>
            <ZInput label="Votre nom" value={name} onChange={(e) => setName(e.target.value)} required data-testid="vclaim-name" />
            <ZInput type="email" label="Votre e-mail" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="vclaim-email" />
          </>
        )}
        {err && <p className="z-error-text" data-testid="vclaim-error">{err}</p>}
        <TermsConsent checked={accept} onChange={setAccept} testId="vclaim-terms-consent" />
        <ZButton type="submit" block loading={loading} disabled={!accept} data-testid="vclaim-submit">Réclamer mon bon</ZButton>
      </form>
    </div>
  );
}
